<template>
  <div style="width:100%;">
    <basic-container>
      <div class="box" style="width:100%;height:740px">
        <span style='display:block;position:relative;top:9%;text-align: center;font-size:28px;font-family:Microsoft YaHei;font-weight:400;color:rgba(43,126,255,1);'>欢迎使用慧家云-家居商户运营平台</span>
         <span style='display:block;position:relative;top:17%;text-align: center;font-size:18px;font-family:Microsoft YaHei;font-weight:400;color:rgba(43,126,255,1);'>———— 智慧家居一体化服务商 ————</span>
        <img
          style="width:502px;height:300px;position:relative;left: 50%;margin-left:-251px;top:205px;"
          src="../../public/img/bg/indexbg.png"
          alt
        />
       <span style="display:block;position:relative;top:38%;text-align: center;font-size:18px;font-family:Microsoft YaHei;font-weight:400;color:rgba(51,51,51,1)">{{company}}</span>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { findUserId, findCompany, userInfo } from "@/api/salesCloud/company";
import { setCompany, getCompany } from "@/util/auth";

export default {
  name: "wel",
  data() {
    return {
      company: "",
      department: "",
      position: "",
      realName: ""
    };
  },
  computed: {},
  created() {
    userInfo().then(res => {
      let data = JSON.parse(res.data);
      this.department = data.department;
      this.position = data.position;
      this.realName = data.realName;
    });
    findUserId().then(res => {
      let data = JSON.parse(res.data);
      console.log(data);
      let userId = data.id;
      findCompany(userId).then(res => {
        let company = res.data;
        setCompany(company);
        let a = getCompany();
        // let getCompany = this.getCompany();
        this.company = a;
      });
    });
  },
  methods: {}
};
</script>

<style scoped="scoped" lang="scss">
.box {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
}
.info {
  padding: 21px 0;
  display: flex;
  align-items: center;
  .img-border {
    width: 64px;
    height: 65px;
    position: relative;
  }
  .img-v {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 22px;
    height: 22px;
  }
  .img {
    border-radius: 5px;
    width: 64px;
    height: 64px;
    display: inline-block;
    overflow: hidden;
    img {
      display: block;
      max-width: none;
      height: 64px;
      opacity: 1;
      width: 64px;
      margin-left: 0px;
      margin-top: 0px;
    }
  }
  .user {
    margin-left: 20px;
    color: rgb(153, 153, 153);
    flex: 1 1 auto;
  }
  .user-img {
    display: flex;
    height: 24px;
    align-items: center;
  }
  .user-title {
    font-size: 18px;
    color: rgb(102, 102, 102);
    margin-right: 5px;
    display: inline-block;
    max-width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .user-subtitle {
    height: 16px;
    line-height: 16px;
    border-radius: 2px;
    padding: 0px 5px;
    margin-left: 10px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 44, 84);
    background-color: rgb(255, 242, 244);
    white-space: nowrap;
  }
  .user-item {
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
